import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Field as HeadlessField } from '@flywire/react-headlessui';
import { cx } from '../../utils';
export const useHintClasses = ({ className }) => {
    return cx('text-xs font-medium text-gray-700', 'hidden group-focus-within/field:block', className);
};
const HintComponent = forwardRef(({ className, ...rest }, ref) => {
    const classes = useHintClasses({ className });
    return _jsx(HeadlessField.Hint, { className: classes, ref: ref, ...rest });
});
HintComponent.displayName = 'Hint';
const Hint = HintComponent;
export { Hint };
//# sourceMappingURL=Hint.js.map